import { EditComponent } from "../../app-lite/table/cell-components/actions/edit.component";

export function VendorInvoicesCtrl($rootScope, $state, $scope, $translate, tableApi, workshopAPI) {
  $scope.showVendorInvoices = !!$scope.invoices.length;
  $scope.tableCacheKey      = 'vendorInvoices';

  $scope.getStatusTypes = function () {
    return workshopAPI
      .get('/system/invoice_status_types')
      .then(function (types) {
        types.unshift({
          code       : '*',
          description: $translate.instant('GENERAL_SPACE.BUTTON.ALL'),
        });

        return types;
      });
  };

  $scope.filtering = tableApi.setFiltersFromCache($scope.tableCacheKey, {
    begin_date : '*',
    end_date   : '*',
    import_type: '*',
    status_type: '*',
  });

  $scope.tableSettings = {
    broadcast: 'filterVendorInvoices',
    cache    : {
      enabled: true,
      key    : $scope.tableCacheKey
    },
    columns: [
      {
        field : 'vendor_invoice_number',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.REFERENCE')
        },
      },
      {
        field : 'post_date',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.POST_DATE')
        },
        pipe: 'globalDate',
      },
      {
        field : 'invoice_type',
        header: {
          text: $translate.instant('JS_SPACE.COLUMNS.TRAN_TYPE')
        },
        pipe: 'invoiceType',
      },
      {
        field : 'invoice_status',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.STATUS')
        },
        pipe: 'invoiceStatus',
      },
      {
        classes: 'text-right',
        field  : 'total',
        header : {
          classes: 'text-right',
          text   : $translate.instant('JS_SPACE.COLUMNS.AMOUNT'),
        },
        pipe: 'globalCurrency',
      },
      {
        classes: 'text-right',
        field  : 'balance_due',
        header : {
          classes: 'text-right',
          text   : $translate.instant('JS_SPACE.COLUMNS.BALANCE'),
        },
        pipe: 'globalCurrency',
      },
      {
        component: {
          bindings: {
            outputs: {
              onEditClick: (event) => $scope.viewInvoice(event),
            },
          },
          enabled: true,
          factory: EditComponent,
        },
        sortable: false,
      },
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_INVOICES_FOUND'),
    },
    pagination: {
      enabled   : true,
      pageSize  : tableApi.getCachedPaging($scope.tableCacheKey).pageSize || 5,
      pageSizes : [5, 10, 25, 50],
      queryCount: () =>
        workshopAPI.get('/vendors/invoice_count', [
          $scope.vendor.id,
          $scope.filtering.status_type,
          '*',
          $scope.filtering.import_type,
          $scope.filtering.begin_date,
          $scope.filtering.end_date,
        ]),
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: tableApi.setSortingFromCache($scope.tableCacheKey, {
      direction: 'desc',
      field    : 'post_date'
    })
  };

  $scope.getInvoices = (params) => {
    return workshopAPI.get('/vendors/invoice_list', [
      $scope.vendor.id,
      params.offset,
      params.pageSize,
      $scope.filtering.status_type || '*',
      '*',
      $scope.filtering.import_type,
      $scope.filtering.begin_date || '*',
      $scope.filtering.end_date || '*',
      params.field,
      params.direction,
    ]).then(invoices => {
      $scope.invoices = invoices;

      return invoices;
    });
  };

  $scope.onRowDoubleClick = function (event) {
    $scope.viewInvoice(event.row);
  };

  $scope.viewInvoice = function (invoice) {
    $state.go('app.vendor-invoice', {
      id       : invoice.id,
      vendor_id: invoice.vendor_id,
    });
  };

  $scope.getStatusTypes().then(function (types) {
    $scope.statusTypes = types;
  });

  $scope.$watch(
    '[ filtering.begin_date, filtering.end_date, filtering.import_type, filtering.status_type ]',
    (newVal, oldVal) => {
      if (newVal !== oldVal) {
        window['filterVendorInvoices']($scope.filtering);
      }
    }
  );
}
